import { motion } from "motion/react";
import { primeObservatoryAudio } from "../experience/ObservatoryAudioRuntime";
import { getCatalog } from "../i18n";
import { panelSpring, uiSpring } from "../lib/motion";
import { useNexusStore } from "../store/nexusStore";

export function MobileDock() {
  const focusCosmos = useNexusStore((state) => state.focusCosmos);
  const setCommandOpen = useNexusStore((state) => state.setCommandOpen);
  const soundEnabled = useNexusStore((state) => state.soundEnabled);
  const toggleSound = useNexusStore((state) => state.toggleSound);
  const accessibleMode = useNexusStore((state) => state.accessibleMode);
  const toggleAccessibleMode = useNexusStore((state) => state.toggleAccessibleMode);
  const locale = useNexusStore((state) => state.locale);
  const ui = getCatalog(locale).ui;

  const tap = { scale: 0.93, y: 1 };

  return (
    <motion.nav
      className="mobile-dock"
      aria-label={ui.semanticMap}
      initial={{ opacity: 0, y: 16, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={panelSpring}
    >
      <motion.button whileTap={tap} transition={uiSpring} onClick={focusCosmos} aria-label={ui.returnToCosmos}>
        ◎<span>{ui.cosmos}</span>
      </motion.button>
      <motion.button whileTap={tap} transition={uiSpring} onClick={() => setCommandOpen(true)} aria-label={ui.command}>
        ⌕<span>{ui.find}</span>
      </motion.button>
      <motion.button
        whileTap={tap}
        transition={uiSpring}
        onClick={() => {
          primeObservatoryAudio();
          toggleSound();
        }}
        aria-pressed={soundEnabled}
      >
        {soundEnabled ? "◉" : "○"}
        <span>{ui.sound}</span>
      </motion.button>
      <motion.button
        whileTap={tap}
        transition={uiSpring}
        onClick={toggleAccessibleMode}
        aria-pressed={accessibleMode}
        aria-label={accessibleMode ? ui.accessibleObservatoryOn : ui.accessibleObservatoryOff}
      >
        {accessibleMode ? "◈" : "◇"}
        <span>{ui.access}</span>
      </motion.button>
    </motion.nav>
  );
}
